import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Navi = _resolveComponent("Navi")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ConsentBanner = _resolveComponent("ConsentBanner")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_Navi, {
      isDarkMode: _ctx.isDarkMode,
      onChangeTheme: _ctx.switchTheme
    }, null, 8, ["isDarkMode", "onChangeTheme"]),
    _createVNode(_component_router_view),
    (_ctx.showConsentBanner)
      ? (_openBlock(), _createBlock(_component_ConsentBanner, {
          key: 0,
          consentStatus: _ctx.consentStatus,
          onSelectConsent: _ctx.setConsent
        }, null, 8, ["consentStatus", "onSelectConsent"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Footer, { onEditConsent: _ctx.editConsent }, null, 8, ["onEditConsent"])
  ], 64))
}